import { styled } from '@mui/material/styles';
import IconButton, { iconButtonClasses } from '@mui/material/IconButton';

const StyledIconButton = styled(IconButton)(({ theme }) => ({
    [`&.${iconButtonClasses.root}`]: {
        color: theme.palette.text.secondary,
        p: 0,
        m: 0,
    },
}));

export default StyledIconButton;
